import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  trialInfo: null,
  currentDate: null,
  allEvents: [],
  selectedEvent: null,
  isOpen: false,
  calOpen: false,
  meetId: null,
  callCount: 0,
  popupPosition: {top: 0, left: 0},
};

const calendarSlice = createSlice({
  name: "calendar",
  initialState,
  reducers: {
    setTrialInfo(state, action) {
      state.trialInfo = action.payload;
    },
    setCurrentDate(state, action) {
      state.currentDate = action.payload;
    },
    setAllEvents(state, action) {
      state.allEvents = action.payload;
    },
    setSelectedEvent(state, action) {
      state.selectedEvent = action.payload;
    },
    setIsOpen(state, action) {
      state.isOpen = action.payload;
    },
    setCalOpen(state, action) {
      state.calOpen = action.payload;
    },
    setMeetId(state, action) {
      state.meetId = action.payload;
    },
    setCallCount(state, action) {
      state.callCount = action.payload;
    },
    setPopupPosition(state, action) {
      state.popupPosition = action.payload;
    }
  },
});

export const {
  setTrialInfo,
  setCurrentDate,
  setAllEvents,
  setSelectedEvent,
  setIsOpen,
  setCalOpen,
  setMeetId,
  setCallCount,
  setPopupPosition,
} = calendarSlice.actions;

export default calendarSlice.reducer;
